'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _theme = require('../theme');

var _mixins = require('../utils/mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getKeyframes = function getKeyframes() {
  var _ref;

  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return _ref = {}, _defineProperty(_ref, delay + '%', {
    transform: 'scale(1) translate3d(0, 0, 0)'
  }), _defineProperty(_ref, 20 + delay + '%', {
    transform: 'scale(1) translate3d(0, 100%, 0)'
  }), _defineProperty(_ref, 80 + delay + '%', {
    transform: 'scale(1) translate3d(0, 0, 0)'
  }), _ref;
};

var Spinner = (_dec = (0, _theme.injectSheet)(function (theme) {
  return {
    '@keyframes ruiAnimateDot1': getKeyframes(),
    '@keyframes ruiAnimateDot2': getKeyframes(100 / (600 / 80)),
    '@keyframes ruiAnimateDot3': getKeyframes(100 / (600 / 160)),
    spinner: {
      extend: [_mixins.isolateMixin, _mixins.middleMixin],
      display: 'inline-block',
      color: theme.spinner.color,
      verticalAlign: 'middle',
      pointerEvents: 'none',
      fontSize: 5,
      whiteSpace: 'nowrap'
    },
    position: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      textAlign: 'center'
    },
    dot: {
      display: 'inline-block',
      verticalAlign: 'middle',
      height: '1em',
      width: '1em',
      position: 'relative',
      top: '-' + 2 / 5 + 'em',
      borderRadius: '50%',
      color: 'inherit!important',
      background: 'currentColor',
      transition: 'transform .6s ease-out',
      transform: 'translate3d(0, 0, 0)',
      animation: '.6s ease-out',
      animationFillMode: 'forwards',
      animationIterationCount: 'infinite',
      '&:nth-child(1)': {
        animationName: 'ruiAnimateDot1'
      },
      '&:nth-child(2)': {
        animationName: 'ruiAnimateDot2',
        margin: '0 1em'
      },
      '&:nth-child(3)': {
        animationName: 'ruiAnimateDot3'
      }
    }
  };
}, { name: 'Spinner' }), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  _inherits(Spinner, _PureComponent);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          color = _props.color,
          size = _props.size,
          inline = _props.inline,
          classes = _props.classes;


      var resultStyle = _extends({
        fontSize: size,
        color: color
      }, style);

      var dot = _react2.default.createElement('span', { className: classes.dot });

      return _react2.default.createElement(
        'span',
        {
          style: resultStyle,
          className: (0, _classnames2.default)(className, classes.spinner, !inline && classes.position) },
        dot,
        dot,
        dot
      );
    }
  }]);

  return Spinner;
}(_react.PureComponent), _class2.defaultProps = {
  inline: false
}, _temp)) || _class);
exports.default = Spinner;
Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * CSS-класс
   */
  className: _propTypes2.default.string,
  /**
   * Inline-стили
   */
  style: _propTypes2.default.object,
  /**
   * Цвет точек
   */
  color: _propTypes2.default.string,
  /**
   * Размер точек
   */
  size: _propTypes2.default.number,
  /**
   * Сделать строчным элементом
   */
  inline: _propTypes2.default.bool
} : {};